import { render, staticRenderFns } from "./goodsRate.vue?vue&type=template&id=50b972ca&scoped=true"
import script from "./goodsRate.vue?vue&type=script&lang=js"
export * from "./goodsRate.vue?vue&type=script&lang=js"
import style0 from "./goodsRate.vue?vue&type=style&index=0&id=50b972ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b972ca",
  null
  
)

export default component.exports